import PlayerJoin, {TYPE_PLAYER_JOIN} from './PlayerJoin.js'
import PlayerMove, {TYPE_PLAYER_MOVE} from './PlayerMove.js'
import PlayerLeave, {TYPE_PLAYER_LEAVE} from './PlayerLeave.js'
import WallChanged, {TYPE_WALL_CHANGED} from './WallChanged.js'
import WallDestroyed, {TYPE_WALL_DESTROYED} from './WallDestroyed.js'
import BulletChanged, {TYPE_BULLET_CHANGED} from './BulletChanged.js'
import BulletDestroyed, {TYPE_BULLET_DESTROYED} from './BulletDestroyed.js'

class Factory  {
    
    create(type, data) {
        let message = null;
        if(type == TYPE_PLAYER_JOIN) {
            message = new PlayerJoin(data);
        } else if(type == TYPE_PLAYER_MOVE) {
            message = new PlayerMove(data);
        } else if(type == TYPE_PLAYER_LEAVE) {
            message = new PlayerLeave(data);
        } else if(type == TYPE_WALL_CHANGED) {
            message = new WallChanged(data);
        } else if(type == TYPE_WALL_DESTROYED) {
            message = new WallDestroyed(data);
        } else if(type == TYPE_BULLET_CHANGED) {
            message = new BulletChanged(data);
        } else if(type == TYPE_BULLET_DESTROYED) {
            message = new BulletDestroyed(data);
        } else {
            throw new Error('Invalid message type "' + type + '"');
        }
        
        return message;
    }
    
}

export default Factory
